const memberCategories = [
    'Barnfamilj',
    'Ensamhushåll',
    'Par',
    'Pensionär',
    'Annat',
];
export default memberCategories;
